import * as types from "./constant"

const initialState = {
  Loading: false,
  error: null,
  notification: [],
  notificationCount: {},
  birthNotification: [],
  AnniversaryNotification: [],
  Followups: [],
  sendNotiMsg: "",
  notificationDeleted: false,
  claimNotification: []
}

const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_NOTIFICATION_START:
    case types.DELETE_NOTIFICATION:
      return {
        ...state,
        Loading: true,
        error: null,
        sendNotiMsg: "",
        notificationDeleted: false
      }
    case types.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        Loading: false,
        notification: action.payload.notifications,
        notificationCount: action.payload.notificationCount,
        birthNotification: action.payload.BirthdayNotification,
        AnniversaryNotification: action.payload.AnniversaryNotification,
        Followups: action.payload.Followups,
        claimNotification: action.payload.claimNotification
      }
    case types.GET_NOTIFICATION_FAIL:
      console.log(action.payload)
      return {
        ...state,
        Loading: false,
        error: action.payload.message,
      }
    case types.SEND_NOTIFICATION_START:
    case types.SEND_EMP_MAIL:
      return {
        ...state,
        Loading: true,
        error: "",
        sendNotiMsg: "",
      }
    case types.SEND_NOTIFICATION_SUCCESS:
      return {
        ...state,
        Loading: false,
        sendNotiMsg: action.payload.message
      }
    case types.SEND_EMP_MAIL_SUCCESS:
      return {
        ...state,
        Loading: false,
        sendNotiMsg: action.payload.message
      }
    case types.SEND_NOTIFICATION_FAILS:
    case types.DELETE_NOTIFICATION_FAILED:
    case types.SEND_EMP_MAIL_FAILED:
      return {
        ...state,
        Loading: false,
        error: action.payload
      }

    case types.DELETE_NOTIFICATION_SUCCESS:
      const updatedFollowups = state.Followups.filter(item => item.id !== action.payload.notiId);

      return {
        ...state,
        Followups: updatedFollowups,
        Loading: false,
        sendNotiMsg: action.payload.message,
        notificationDeleted: true,
      };

    case types.RESET_NOTIFICATION_ALERT:
      return {
        ...state,
        error: null,
        sendNotiMsg: ""
      }
    default:
      return state
  }
}

export default NotificationReducer
